import { html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { StyleInfo, styleMap } from 'lit/directives/style-map';
import { TeComponent } from '../common/te-component';
import { theme } from '../common/theme';
import { IconName } from '../te-icon';
import '../te-spacing';
import '../te-text';

/**
 * Label Component
 */
@customElement('te-label')
export class TeLabel extends TeComponent {
  static styles = [
    ...TeComponent.styles,
    css`
      .label-container {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-right: 8px;
        border-radius: 10px;
        height: 20px;
        width: fit-content;
        box-sizing: content-box;
      }
    `,
  ];

  /** Background color of label */
  @property({ type: String }) backgroundColor = theme.colors.primary.v0.toString();
  /** Color of text */
  @property({ type: String }) textColor = theme.colors.shade0.toString();
  /** Primary text value */
  @property({ type: String }) text = '';
  /** Icon name from icon pack */
  @property({ type: String }) icon?: IconName;
  /** Color of icon */
  @property({ type: String }) iconColor?: string;
  /** Size of icon */
  @property({ type: Number }) iconSize?: number;
  /** Border color of label */
  @property({ type: String }) borderColor?: string;

  renderIcon() {
    const { icon, iconSize = 14, iconColor = theme.colors.shade5.toString() } = this;
    if (!icon) return;
    const iconHtml = html`
      <te-icon name=${icon} color=${iconColor} size=${iconSize}></te-icon>
    `;
    const spacing = this.text
      ? html`
          <te-spacing size="8"></te-spacing>
        `
      : html``;
    return [iconHtml, spacing];
  }

  renderText() {
    return html`
      <te-text color=${this.textColor} size="12" weight="500">${this.text}</te-text>
    `;
  }

  getStyle(): StyleInfo {
    return {
      backgroundColor: this.backgroundColor,
      paddingLeft: this.icon ? '3px' : '8px',
      border: this.borderColor ? `2px solid ${this.borderColor}` : 'unset',
    };
  }

  render() {
    return html`
      <span class="label-container" style=${styleMap(this.getStyle())}>
        ${this.renderIcon()} ${this.renderText()}
      </span>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'te-label': TeLabel;
  }
}
